var map = {
	"./avatar-01.jpg": 54802,
	"./avatar-02.jpg": 92605,
	"./avatar-03.jpg": 24512,
	"./avatar-04.jpg": 14675,
	"./avatar-05.jpg": 86262,
	"./avatar-06.jpg": 62049,
	"./avatar-07.jpg": 88452,
	"./avatar-08.jpg": 83607,
	"./avatar-09.jpg": 31674,
	"./avatar-10.jpg": 16880,
	"./avatar-11.jpg": 17805,
	"./avatar-12.jpg": 88546,
	"./avatar-13.jpg": 1215,
	"./avatar-14.jpg": 80404,
	"./avatar-15.jpg": 77777,
	"./avatar-16.jpg": 36358,
	"./avatar-17.jpg": 58531,
	"./avatar-18.jpg": 95032,
	"./reviewauthor-2.svg": 23915,
	"./reviewauthor-3.svg": 18650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91403;